export const PRODUCTS_DROPSHIP = 'PRODUCTS_DROPSHIP';
export const PRODUCTS_DROPSHIP_OFFSET = 'PRODUCTS_DROPSHIP_OFFSET';
export const PRODUCTS_DROPSHIP_COUNT = 'PRODUCTS_DROPSHIP_COUNT';
export const PRODUCTS_DROPSHIP_RETAILERS = 'PRODUCTS_DROPSHIP_RETAILERS';
export const PRODUCTS_DROPSHIP_SEARCH = 'PRODUCTS_DROPSHIP_SEARCH';
export const PRODUCTS_DROPSHIP_CHECK = 'PRODUCTS_DROPSHIP_CHECK';
export const PRODUCTS_DROPSHIP_UNCHECK = 'PRODUCTS_DROPSHIP_UNCHECK';
export const PRODUCTS_DROPSHIP_UNCHECK_ALL = 'PRODUCTS_DROPSHIP_UNCHECK_ALL';
export const PRODUCTS_DROPSHIP_ALL = 'PRODUCTS_DROPSHIP_ALL';
export const PRODUCTS_DROPSHIP_CHECK_ALL_ON_PAGE = 'PRODUCTS_DROPSHIP_CHECK_ALL_ON_PAGE';
export const PRODUCTS_DROPSHIP_LOADING = 'PRODUCTS_DROPSHIP_LOADING';
export const PRODUCTS_DROPSHIP_LOADING_PRODUCTS = 'PRODUCTS_DROPSHIP_LOADING_PRODUCTS';
